module.exports = __webpack_public_path__ + "static/media/meat23.994c842f.jpg";